var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"px-6",staticStyle:{"margin-top":"14px","border-radius":"16px"},attrs:{"outlined":""}},[_vm._t("header"),(_vm.title)?_c('v-card-title',{staticClass:"pt-4 pb-2 px-0",staticStyle:{"text-shadow":"grey 0.1em 0.1em 0.2em"}},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }